import { FC, memo, useContext } from "react";
import Popup from ".";
import { Context } from "../../context";
import { useTranslation } from "react-i18next";
import { IPopupContainer } from "./popup.types/PopupContainer.type";
import "./style.css";

const PopupContainer: FC<IPopupContainer> = ({
  recordID,
  onApply,
  Name,
  modalName = "CuPop",
  resetAllFields,
  children,
  modalID,
  AdditionalTitle,
  isValidToSubmit = true
}) => {
  const { loading } = useContext(Context);
  const { t } = useTranslation();

  const handleClose = () => {
    if (resetAllFields && !recordID) resetAllFields();
    modalID.current.click();
  };

  return (
    <>
      <div className="add-new-pation">
        <button
          ref={modalID}
          data-bs-toggle="modal"
          data-bs-target={`#${modalName + recordID}`}
          hidden
        ></button>
        <Popup
          name={`${modalName + recordID}`}
          large={true}
          title={t(`${Name}`) + `${AdditionalTitle ? AdditionalTitle : ''}`}
          onClose={handleClose}
        >
          <div className="d-flex flex-column justify-content-center">
            <div className="row">
              {children}
            </div>
            {
              onApply &&
              <button className="popup-btn" onClick={onApply}
                //@ts-ignore
                disabled={!isValidToSubmit}>
                <div
                  className={loading ? "spinner-border spinner-border-sm" : ""}
                  aria-hidden="true"
                ></div>
                {t("Save")}
              </button>
            }
          </div>
        </Popup>
      </div>
    </>
  );
};

export default memo(PopupContainer);
